<template>
  <div class="privacy-consent">
    <h3>{{title}}</h3>
    <div class="consent-content">
      <div class="consent-text" v-html="contents"></div>
      <div class="consent-checkbox" v-if="label">
        <input
          :id="checkboxId"
          type="checkbox"
          v-model="checked"
        />
        <label :for="checkboxId" >
          {{label}}<span class="required">*</span>
        </label>
        <div class="checkbox-icon">
          <img
            src="https://img.davich.com/image/sub/icon-form-checkbox.jpg"
            alt="checkbox icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyConsent',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    contents: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    checkboxId: {
      type: String,
      default: 'privacy-consent-checkbox'
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";

.privacy-consent {
  margin-top: 50px;

  h3 {
    //@include font-h-25;
    margin-bottom: 20px;
    //color: $color-black;
    font-weight: 700;
    font-size: 22px;
    leading-trim: NONE;
    line-height: 30px;
    letter-spacing: -0.66px;
    vertical-align: middle;

  }

  .consent-content {
    //border-radius: 4px;
    //padding: 30px;

    .consent-text {
      width: 100%;
      border-bottom: 1px solid #e0e0e0;
      //max-width: 362px;
      max-height: 255px;
      overflow-y: auto;
      overflow-x: clip;
      padding: 20px;
      font-weight: 350;
      font-size: 20.12px;
      leading-trim: NONE;
      line-height: 33.96px;
      letter-spacing: -0.6px;
      vertical-align: middle;
      margin-bottom: 30px;
      color: #666;
      &::-webkit-scrollbar {
        width: 10px;
      }

      &::-webkit-scrollbar-track {
        //background: #f1f1f1aa;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        //border-radius: 4px;
        &:hover {
          background: #aaa;
        }
      }
    }

    .consent-checkbox {
      display: flex;
      align-items: center;
      position: relative;

      input[type="checkbox"] {
        width: 32px;
        height: 32px;
        margin-right: 10px;
        //margin-top: -15px;
        cursor: pointer;
        appearance: none;
        border: 1px solid #ddd;
        //border-radius: 4px;
        position: relative;
        flex-shrink: 0;

        &:checked {
          background-color: $color-blue;
          border-color: $color-blue;

          &::after {
            content: '';
            position: absolute;
            left: 10px;
            top: 5px;
            width: 8px;
            height: 14px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
          }
        }

        &:hover {
          border-color: #666;
        }
      }

      label {
        font-weight:500;
        font-size: 18.87px;
        leading-trim: NONE;
        line-height: 31.45px;
        vertical-align: middle;
        //font-size: 16px;
        color: $color-black;
        cursor: pointer;
        user-select: none;

        .required {
          color: $color-skyblue;
          margin-left: 4px;
        }
      }

      .checkbox-icon {
        display: none;
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 40px;

    h3 {
      font-size: 20px;
      margin-bottom: 16px;
    }

    .consent-content {
      //padding: 20px;
      .consent-text {
        //max-height: 150px;
        padding: 0;
        font-size: 15px;
      }

      .consent-checkbox {
        label {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
